import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { tab: String } // e.g. "custom" or "imo"
  static targets = ["refSpeed", "refSpeedHidden", "iceClass", "imoShipType"]

  connect() {
    this.updateVisibility()
  }

  updateVisibility() {
    this.dispatch("toggleSelected", { detail: {} })
  }

  updateHidden(event) {
    const newValue = event.target.value
    if (this.hasRefSpeedHiddenTarget) {
      this.refSpeedHiddenTarget.value = newValue
    }
  }

  syncIceClass(event) {
    const selectedValue = event.target.value
    this.iceClassTargets.forEach(select => {
      select.value = selectedValue
    })
  }

  syncImoShipType(event) {
    const selectedValue = event.target.value
    this.imoShipTypeTargets.forEach(select => {
      select.value = selectedValue
    })
  }

  submitForm(event) {
    const form = event.target.closest('form')
    if (form) {
      if (form.reportValidity()) {
        form.requestSubmit()
      }
    }
  }

  stopDropdownClick(event) {
    const clicked = event.target
    if (!clicked.closest('.button') || clicked.closest('.eexi-custom-button')) {
      event.stopPropagation()
    }
  }
}
